import React, { useState } from 'react';
import { Infinity, Info, Play, MessageCircle, Shield } from 'lucide-react';
import './UpgradeModal.css';
import { isStripeBillingEnabled } from '../config/stripe';
import { SHOW_QUIZ_FEATURES } from '../config/features';

const UpgradeModal = ({ isOpen, onClose, feature, currentUsage, limit }) => {
    const [selectedPlan, setSelectedPlan] = useState('yearly'); // 'yearly' or 'monthly'
    
    if (!isOpen) return null;

    const features = [
        { icon: Infinity, text: 'Unlimited AI notes, recordings, uploads', subtitle: 'Unlimited AI responses/month' },
        {
            icon: Info,
            text: SHOW_QUIZ_FEATURES ? 'Quizzes, videos, podcasts, & more' : 'Videos, podcasts, & more',
            subtitle: '6/uploads/day'
        },
        {
            icon: Play,
            text: 'YouTube, PDF, audio, files, websites',
            subtitle: SHOW_QUIZ_FEATURES ? 'Live quizzes' : 'Multi-format study'
        },
        { icon: MessageCircle, text: 'Chat with your notes', subtitle: SHOW_QUIZ_FEATURES ? 'Auto-grading' : 'Instant answers' },
        { icon: Shield, text: 'Private and secure', subtitle: 'Export features' }
    ];

    const handleUpgrade = () => {
        if (!isStripeBillingEnabled()) {
            return;
        }
        if (selectedPlan === 'yearly') {
            // Yearly plan Stripe link - Replace with your actual Stripe URL
            window.open('https://buy.stripe.com/6oUaEX2W8ac8eTw37Ce3e00', '_blank');
        } else {
            // Monthly plan Stripe link - Replace with your actual Stripe URL
            window.open('https://buy.stripe.com/bJe8wP54gckg4eS8rWe3e01', '_blank');
        }
    };

    return (
        <div className="upgrade-modal-overlay" onClick={onClose}>
            <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
                <div className="upgrade-modal-header">
                    <button className="upgrade-modal-close" onClick={onClose}>
                        ✕
                    </button>
                </div>
                
                <div className="upgrade-modal-content">
                    {/* Header */}
                    <div className="upgrade-header">
                        <img src="https://iili.io/KYpg7rg.png" alt="Study-Space Logo" className='upgrade-modal-logo' />
                        <h2>Upgrade to Unlimited</h2>
                        <p className="upgrade-modal-subtitle">Try Study-Space for free for first 7 days</p>
                    </div>
                    
                    {/* Features List */}
                    <div className="features-list">
                        {features.map((feature, index) => {
                            const IconComponent = feature.icon;
                            return (
                                <div key={index} className="feature-item">
                                    <div className="feature-icon">
                                        <IconComponent size={14} />
                                    </div>
                                  <div>
                                    <span className="feature-text">{feature.text}</span>
                                    <p className="feature-subtitle">{feature.subtitle}</p>
                                    </div>
                                  
                                    {/* <span className="feature-subtitle">{feature.subtitle}</span> */}
                                </div>
                            );
                        })}
                    </div>
                    
                    {/* Subscription Options */}
                    <div className="subscription-options">
                        <button 
                            className={`plan-button ${selectedPlan === 'yearly' ? 'selected' : ''}`}
                            onClick={() => setSelectedPlan('yearly')}
                        >
                            <span>Yearly $99</span>
                            <div className="savings-badge">SAVE 40%</div>
                        </button>
                        <button 
                            className={`plan-button ${selectedPlan === 'monthly' ? 'selected' : ''}`}
                            onClick={() => setSelectedPlan('monthly')}
                        >
                            <span>Monthly $25</span>
                        </button>
                    </div>
                    
                    {/* Main CTA */}
                    <button 
                        className="main-cta-button"
                        onClick={handleUpgrade}
                    >
                        {selectedPlan === 'yearly' ? 'Try Study-Space for $0' : 'Get Unlimited Pass'}
                    </button>
                    
                    {/* Additional Info */}
                    {/* <p className="no-risk-text">No risk, no payment today</p> */}
                    
                    {/* <div className="social-proof">
                        <div className="avatars">
                            <div className="avatar">👩</div>
                            <div className="avatar">👨</div>
                            <div className="avatar">👩</div>
                        </div>
                        <span className="social-text">950 others started today</span>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default UpgradeModal;

